export const displayStatus = {
  AdminAccepted: "Accepted",
  AdminRejected: "Rejected",
  Pending: "Pending",
  UserCancelled: "Cancelled By User",
  AdminCompleted: "Completed",
};
